//缺6、铜夹
import makerjs from "makerjs";
// 矩形等去角 连线函数
function creatmyCopperClipGapH(area, param) {
  console.log("是否调用此函数creatOneCorner（）");
  console.log("是否调用此函数creatOneCorner（）param=", param);
  var xa = param.xa, ya = param.ya, xb = param.xb, 
  yb = param.yb, xc = param.xc, 
  yc = param.yc, xg = param.xg, yg = param.yg, 
  xd = param.xd, yd = param.yd, xf = param.xf, yf = param.yf,glassH=param.glassH,glassW=param.glassW, 
  xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi,  
  x = param.x0, r = param.r, rd = param.rd,w = param.w,h1 = param.h1, h = param.h,d = param.d,
  cutLine=param.cutLine,cutFilletRadius=param.cutFilletRadius; 
  if(glassW*1<glassH * 1){
      console.log("长边在X轴￥￥￥￥￥");
      if (area == "A") {
            var myCopperClipGapH = {
              paths: {
                    "LeftLine": new makerjs.paths.Line([xa, ya], [xa, ya-h]),
                    "BottomLine": new makerjs.paths.Line([xa, ya-h], [xa+w, ya-h]),
                    "RightLine": new makerjs.paths.Line([xa+w, ya-h], [xa+w, ya]),
                    "Holes":new makerjs.paths.Circle([xa+w/2,ya-h1], d/2),
                  }
            };
            var myCopperClipGapHWaterCut = {
              paths: {
                    "EnLine": new makerjs.paths.Line([xa, ya+cutLine], [xa, ya]),
                    "LeftLine": new makerjs.paths.Line([xa, ya], [xa, ya-h]),
                    "BottomLineLf": new makerjs.paths.Line([xa, ya-h], [xa+w/2, ya-h]),
                    "SlotLineLf": new makerjs.paths.Line([xa+w/2, ya-h], [xa+w/2, ya-h1+d/2]),
                    "HolesLf":new makerjs.paths.Arc([xa+w/2, ya-h1+d/2],[xa+w/2,ya-h1-d/2], d/2,false,false),
                    "HolesRt":new makerjs.paths.Arc([xa+w/2,ya-h1-d/2],[xa+w/2, ya-h1+d/2], d/2,false,false),
                    "SlotLineRt": new makerjs.paths.Line([xa+w/2, ya-h1+d/2], [xa+w/2, ya-h]),
                    "BottomLineRt": new makerjs.paths.Line([xa+w/2, ya-h], [xa+w, ya-h]),
                    "RightLine": new makerjs.paths.Line([xa+w, ya-h], [xa+w, ya]),
                    "ExLine": new makerjs.paths.Line([xa+w, ya], [xa+w, ya+cutLine]),
                  }
            };
          } else if (area == "B") {
            var myCopperClipGapH = {
                  paths: {
                        "LeftLine": new makerjs.paths.Line([xb-w/2, yb], [xb-w/2, yb-h]),
                        "BottomLine": new makerjs.paths.Line([xb-w/2, yb-h], [xb+w/2, yb-h]),
                        "RightLine": new makerjs.paths.Line([xb+w/2, yb-h], [xb+w/2, yb]),
                        "Holes":new makerjs.paths.Circle([xb,yb-h1], d/2),
                      }
                };
                var myCopperClipGapHWaterCut = {
                      paths: {
                        "EnLine": new makerjs.paths.Line([xb-w/2, yb+cutLine], [xb-w/2, yb]),
                        "LeftLine": new makerjs.paths.Line([xb-w/2, yb], [xb-w/2, yb-h]),
                        "BottomLineLf": new makerjs.paths.Line([xb-w/2, yb-h], [xb, yb-h]),
                        "SlotLineLf": new makerjs.paths.Line([xb, yb-h], [xb, yb-h1+d/2]),
                        "HolesLf":new makerjs.paths.Arc([xb, yb-h1+d/2],[xb,yb-h1-d/2], d/2,false,false),
                        "HolesRt":new makerjs.paths.Arc([xb,yb-h1-d/2],[xb, yb-h1+d/2], d/2,false,false),
                        "SlotLineRt": new makerjs.paths.Line([xb, yb-h1+d/2], [xb, yb-h]),
                        "BottomLineRt": new makerjs.paths.Line([xb, yb-h], [xb+w/2, yb-h]),
                        "RightLine": new makerjs.paths.Line([xb+w/2, yb-h], [xb+w/2, yb]),
                        "ExLine": new makerjs.paths.Line([xb+w/2, yb], [xb+w/2, yb+cutLine]),
                          }
                    };
          } else if (area == "C") {
            var myCopperClipGapH = {
                  paths: {
                        "LeftLine": new makerjs.paths.Line([xc-w, yc], [xc-w, yc-h]),
                        "BottomLine": new makerjs.paths.Line([xc-w, yc-h], [xc, yc-h]),
                        "RightLine": new makerjs.paths.Line([xc, ya-h], [xc, ya]),
                        "Holes":new makerjs.paths.Circle([xc-w/2,yc-h1], d/2),
                      }
                };
                var myCopperClipGapHWaterCut = {
                      paths: {
                            "EnLine": new makerjs.paths.Line([xc-w, yc+cutLine], [xc-w, yc]),
                            "LeftLine": new makerjs.paths.Line([xc-w, yc], [xc-w, yc-h]),
                            "BottomLineLf": new makerjs.paths.Line([xc-w, yc-h], [xc-w/2, yc-h]),
                            "SlotLineLf": new makerjs.paths.Line([xc-w/2, yc-h], [xc-w/2,yc-h1+d/2]),
                            "HolesLf":new makerjs.paths.Arc([xc-w/2,yc-h1+d/2],[xc-w/2,yc-h1-d/2], d/2,false,false),
                            "HolesRt":new makerjs.paths.Arc([xc-w/2,yc-h1-d/2],[xc-w/2,yc-h1+d/2], d/2,false,false),
                            "SlotLineRt": new makerjs.paths.Line([xc-w/2,yc-h1+d/2], [xc-w/2, yc-h]),
                            "BottomLineRt": new makerjs.paths.Line([xc-w/2, yc-h], [xc, yc-h]),
                            "RightLine": new makerjs.paths.Line([xc, yc-h], [xc, yc]),
                            "ExLine": new makerjs.paths.Line([xc, yc], [xc, yc+cutLine]),
                          }
                    };
          } else if (area == "G") {
            var myCopperClipGapH = {
                  paths: {
                        "LeftLine": new makerjs.paths.Line([xg, yg], [xg, yg+h]),
                        "BottomLine": new makerjs.paths.Line([xg, yg+h], [xg+w, yg+h]),
                        "RightLine": new makerjs.paths.Line([xg+w, yg+h], [xg+w, yg]),
                        "Holes":new makerjs.paths.Circle([xg+w/2,yg+h1], d/2),
                      }
                };
                var myCopperClipGapHWaterCut = {
                      paths: {
                        "EnLine": new makerjs.paths.Line([xg, yg-cutLine], [xg, yg]),
                        "LeftLine": new makerjs.paths.Line([xg, yg], [xg, yg+h]),
                        "BottomLineLf": new makerjs.paths.Line([xg, yg+h], [xg+w/2, yg+h]),
                        "SlotLineLf": new makerjs.paths.Line([xg+w/2, yg+h], [xg+w/2, yg+h1-d/2]),
                        "HolesLf":new makerjs.paths.Arc([xg+w/2, yg+h1-d/2],[xg+w/2,yg+h1+d/2], d/2,false,false),
                        "HolesRt":new makerjs.paths.Arc([xg+w/2,yg+h1+d/2],[xg+w/2, yg+h1-d/2], d/2,false,false),
                        "SlotLineRt": new makerjs.paths.Line([xg+w/2, yg+h1-d/2], [xg+w/2, yg+h]),
                        "BottomLineRt": new makerjs.paths.Line([xg+w/2, yg+h], [xg+w, yg+h]),
                        "RightLine": new makerjs.paths.Line([xg+w, yg+h], [xg+w, yg]),
                        "ExLine": new makerjs.paths.Line([xg+w, yg], [xg+w, yg-cutLine]),
                          }
                    };
          } else if (area == "H") {
            var myCopperClipGapH = {
                  paths: {
                        "LeftLine": new makerjs.paths.Line([xh-w/2, yh], [xh-w/2, yh+h]),
                        "BottomLine": new makerjs.paths.Line([xh-w/2, yh+h], [xh+w/2, yh+h]),
                        "RightLine": new makerjs.paths.Line([xh+w/2, yh+h], [xh+w/2, yh]),
                        "Holes":new makerjs.paths.Circle([xh,yh+h1], d/2),
                      }
                };
                var myCopperClipGapHWaterCut = {
                      paths: {
                        "EnLine": new makerjs.paths.Line([xh-w/2, yh-cutLine], [xh-w/2, yh]),
                        "LeftLine": new makerjs.paths.Line([xh-w/2, yh], [xh-w/2, yh+h]),
                        "BottomLineLf": new makerjs.paths.Line([xh-w/2, yh+h], [xh, yh+h]),
                        "SlotLineLf": new makerjs.paths.Line([xh, yh+h], [xh, yh+h1-d/2]),
                        "HolesLf":new makerjs.paths.Arc([xh, yh+h1-d/2],[xh,yh+h1+d/2], d/2,false,false),
                        "HolesRt":new makerjs.paths.Arc([xh,yh+h1+d/2],[xh, yh+h1-d/2], d/2,false,false),
                        "SlotLineRt": new makerjs.paths.Line([xh, yh+h1-d/2], [xh, yh+h]),
                        "BottomLineRt": new makerjs.paths.Line([xh, yh+h], [xh+w/2, yh+h]),
                        "RightLine": new makerjs.paths.Line([xh+w/2, yh+h], [xh+w/2, yh]),
                        "ExLine": new makerjs.paths.Line([xh+w/2, yh], [xh+w/2, yh-cutLine]),
                          }
                    };
          } else if (area == "I") {
            var myCopperClipGapH = {
               paths: {
                 "LeftLine": new makerjs.paths.Line([xi-w, yi], [xi-w, yi+h]),
                 "BottomLine": new makerjs.paths.Line([xi-w, yi+h], [xi, yi+h]),
                 "RightLine": new makerjs.paths.Line([xi, yi+h], [xi, yi]),        
                 "Holes":new makerjs.paths.Circle([xi-w/2,yi+h1], d/2),
               }
         };
         var myCopperClipGapHWaterCut = {
            paths: {
                  "EnLine": new makerjs.paths.Line([xi-w, yi-cutLine], [xi-w, yi]),
                  "LeftLine": new makerjs.paths.Line([xi-w, yi], [xi-w, yi+h]),
                  "BottomLineLf": new makerjs.paths.Line([xi-w, yi+h], [xi-w/2, yi+h]),
                  "SlotLineLf": new makerjs.paths.Line([xi-w/2, yi+h], [xi-w/2,yi+h1-d/2]),
                  "HolesLf":new makerjs.paths.Arc([xi-w/2,yi+h1-d/2],[xi-w/2,yi+h1+d/2], d/2,false,false),
                  "HolesRt":new makerjs.paths.Arc([xi-w/2,yi+h1+d/2],[xi-w/2,yi+h1-d/2], d/2,false,false),
                  "SlotLineRt": new makerjs.paths.Line([xi-w/2,yi+h1-d/2], [xi-w/2, yi+h]),
                  "BottomLineRt": new makerjs.paths.Line([xi-w/2, yi+h], [xi, yi+h]),
                  "RightLine": new makerjs.paths.Line([xi, yi+h], [xi, yi]),
                  "ExLine": new makerjs.paths.Line([xi, yi], [xi, yi-cutLine]),
            }
      };
          }
}else{
      console.log("短边在X轴￥￥￥￥￥");
         if (area == "A") {
            var myCopperClipGapH = {
              paths: {
                    "LeftLine": new makerjs.paths.Line([xa, ya], [xa+h, ya]),
                    "BottomLine": new makerjs.paths.Line([xa+h, ya], [xa+h, ya-w]),
                    "RightLine": new makerjs.paths.Line([xa+h, ya-w], [xa, ya-w]),
                    "Holes":new makerjs.paths.Circle([xa+h1,ya-w/2], d/2),
                  }
            };
            var myCopperClipGapHWaterCut = {
              paths: {
                    "EnLine": new makerjs.paths.Line([xa-cutLine, ya], [xa, ya]),
                    "LeftLine": new makerjs.paths.Line([xa, ya], [xa+h, ya]),
                    "BottomLineLf": new makerjs.paths.Line([xa+h, ya], [xa+h, ya-w/2]),
                    "SlotLineLf": new makerjs.paths.Line([xa+h, ya-w/2], [xa+h1-d/2,ya-w/2]),
                    "HolesLf":new makerjs.paths.Arc([xa+h1-d/2,ya-w/2], [xa+h1+d/2,ya-w/2], d/2,false,true),
                    "HolesRt":new makerjs.paths.Arc([xa+h1+d/2,ya-w/2], [xa+h1-d/2,ya-w/2], d/2,false,true),
                    "SlotLineRt": new makerjs.paths.Line([xa+h1-d/2,ya-w/2], [xa+h, ya-w/2]),
                    "BottomLineRt": new makerjs.paths.Line([xa+h, ya-w/2], [xa+h, ya-w]),
                    "RightLine": new makerjs.paths.Line([xa+h, ya-w], [xa, ya-w]),
                    "ExLine": new makerjs.paths.Line([xa, ya-w], [xa-cutLine, ya-w]),
                  }
            };
          } else if (area == "D") {
            var myCopperClipGapH = {
                  paths: {
                      "LeftLine": new makerjs.paths.Line([xd, yd+w/2], [xd+h, yd+w/2]),
                  "BottomLine": new makerjs.paths.Line([xd+h, yd+w/2], [xd+h, yd-w/2]),
                  "RightLine": new makerjs.paths.Line([xd+h, yd-w/2], [xd, yd-w/2]),
                      "Holes":new makerjs.paths.Circle([xd+h1,yd], d/2),
                      }
                };
                var myCopperClipGapHWaterCut = {
                      paths: {
                        "EnLine": new makerjs.paths.Line([xd-cutLine, yd+w/2], [xd, yd+w/2]),
                        "LeftLine": new makerjs.paths.Line([xd, yd+w/2], [xd+h, yd+w/2]),
                        "BottomLineLf": new makerjs.paths.Line([xd+h, yd+w/2], [xd+h, yd]),
                        "SlotLineLf": new makerjs.paths.Line([xd+h, yd], [xd+h1-d/2,yd]),
                        "HolesLf":new makerjs.paths.Arc([xd+h1-d/2,yd], [xd+h1+d/2,yd], d/2,false,true),
                        "HolesRt":new makerjs.paths.Arc([xd+h1+d/2,yd], [xd+h1-d/2,yd], d/2,false,true),
                        "SlotLineRt": new makerjs.paths.Line([xd+h1-d/2,yd], [xd+h, yd]),
                        "BottomLineRt": new makerjs.paths.Line([xd+h, yd], [xd+h, yd-w/2]),
                        "RightLine": new makerjs.paths.Line([xd+h, yd-w/2], [xd, yd-w/2]),
                        "ExLine": new makerjs.paths.Line([xd, yd-w/2], [xd-cutLine, yd-w/2]),
                          }
                    };
          } else if (area == "G") {
            var myCopperClipGapH = {
                  paths: {
                      "LeftLine": new makerjs.paths.Line([xg, yg], [xg+h, yg]),
                      "BottomLine": new makerjs.paths.Line([xg+h, yg], [xg+h, yg+w]),
                      "RightLine": new makerjs.paths.Line([xg+h, yg+w], [xg, yg+w]),
                      "Holes":new makerjs.paths.Circle([xg+h1,yg+w/2], d/2),
                      }
                };
                var myCopperClipGapHWaterCut = {
                      paths: {
                        "EnLine": new makerjs.paths.Line([xg-cutLine, yg], [xg, yg]),
                        "LeftLine": new makerjs.paths.Line([xg, yg], [xg+h, yg]),
                        "BottomLineLf": new makerjs.paths.Line([xg+h, yg], [xg+h, yg+w/2]),
                        "SlotLineLf": new makerjs.paths.Line([xg+h, yg+w/2], [xg+h1-d/2,yg+w/2]),
                        "HolesLf":new makerjs.paths.Arc([xg+h1-d/2,yg+w/2], [xg+h1+d/2,yg+w/2], d/2,false,true),
                        "HolesRt":new makerjs.paths.Arc([xg+h1+d/2,yg+w/2], [xg+h1-d/2,yg+w/2], d/2,false,true),
                        "SlotLineRt": new makerjs.paths.Line([xg+h1-d/2,yg+w/2], [xg+h, yg+w/2]),
                        "BottomLineRt": new makerjs.paths.Line([xg+h, yg+w/2], [xg+h, yg+w]),
                        "RightLine": new makerjs.paths.Line([xg+h, yg+w], [xg, yg+w]),
                        "ExLine": new makerjs.paths.Line([xg, yg+w], [xg-cutLine, yg+w]),
                          }
                    };
          } else if (area == "C") {
            var myCopperClipGapH = {
                  paths: {
                      "LeftLine": new makerjs.paths.Line([xc, yc], [xc-h, yc]),
                     "BottomLine": new makerjs.paths.Line([xc-h, yc], [xc-h, yc-w]),
                     "RightLine": new makerjs.paths.Line([xc-h, yc-w], [xc, yc-w]),
                      "Holes":new makerjs.paths.Circle([xc-h1,yc-w/2], d/2),
                      }
                };
                var myCopperClipGapHWaterCut = {
                      paths: {
                        "EnLine": new makerjs.paths.Line([xc+cutLine, yc], [xc, yc]),
                        "LeftLine": new makerjs.paths.Line([xc, yc], [xc-h, yc]),
                        "BottomLineLf": new makerjs.paths.Line([xc-h, yc], [xc-h, yc-w/2]),
                        "SlotLineLf": new makerjs.paths.Line([xc-h, yc-w/2], [xc-h1+d/2,yc-w/2]),
                        "HolesLf":new makerjs.paths.Arc([xc-h1+d/2,yc-w/2], [xc-h1-d/2,yc-w/2], d/2,false,true),
                        "HolesRt":new makerjs.paths.Arc([xc-h1-d/2,yc-w/2], [xc-h1+d/2,yc-w/2], d/2,false,true),
                        "SlotLineRt": new makerjs.paths.Line([xc-h1+d/2,yc-w/2], [xc-h, yc-w/2]),
                        "BottomLineRt": new makerjs.paths.Line([xc-h, yc-w/2], [xc-h, yc-w]),
                        "RightLine": new makerjs.paths.Line([xc-h, yc-w], [xc, yc-w]),
                        "ExLine": new makerjs.paths.Line([xc, yc-w], [xc+cutLine, yc-w]),
                          }
                    };
          } else if (area == "F") {
            var myCopperClipGapH = {
                  paths: {
                      "LeftLine": new makerjs.paths.Line([xf, yf+w/2], [xf-h, yf+w/2]),
                      "BottomLine": new makerjs.paths.Line([xf-h, yf+w/2], [xf-h, yf-w/2]),
                      "RightLine": new makerjs.paths.Line([xf-h, yf-w/2], [xf, yf-w/2]),
                      "Holes":new makerjs.paths.Circle([xf-h1,yf], d/2),
                      }
                };
                var myCopperClipGapHWaterCut = {
                      paths: {
                        "EnLine": new makerjs.paths.Line([xf+cutLine, yf+w/2], [xf, yf+w/2]),
                        "LeftLine": new makerjs.paths.Line([xf, yf+w/2], [xf-h, yf+w/2]),
                        "BottomLineLf": new makerjs.paths.Line([xf-h, yf+w/2], [xf-h, yf]),
                        "SlotLineLf": new makerjs.paths.Line([xf-h, yf], [xf-h1+d/2,yf]),
                        "HolesLf":new makerjs.paths.Arc([xf-h1+d/2,yf], [xf-h1-d/2,yf], d/2,false,true),
                        "HolesRt":new makerjs.paths.Arc([xf-h1-d/2,yf], [xf-h1+d/2,yf], d/2,false,true),
                        "SlotLineRt": new makerjs.paths.Line([xf-h1+d/2,yf], [xf-h, yf]),
                        "BottomLineRt": new makerjs.paths.Line([xf-h, yf], [xf-h, yf-w/2]),
                        "RightLine": new makerjs.paths.Line([xf-h, yf-w/2], [xf, yf-w/2]),
                        "ExLine": new makerjs.paths.Line([xf, yf-w/2], [xf+cutLine, yf-w/2]),
                          }
                    };
          } else if (area == "I") {
            var myCopperClipGapH = {
            paths: {
                "LeftLine": new makerjs.paths.Line([xi, yi], [xi-h, yi]),
                "BottomLine": new makerjs.paths.Line([xi-h, yi], [xi-h, yi+w]),
                "RightLine": new makerjs.paths.Line([xi-h, yi+w], [xi, yi+w]),
                "Holes":new makerjs.paths.Circle([xi-h1,yi+w/2], d/2),
            }
             };
             var myCopperClipGapHWaterCut = {
             paths: {
                  "EnLine": new makerjs.paths.Line([xi+cutLine, yi], [xi, yi]),
                  "LeftLine": new makerjs.paths.Line([xi, yi], [xi-h, yi]),
                  "BottomLineLf": new makerjs.paths.Line([xi-h, yi], [xi-h, yi+w/2]),
                  "SlotLineLf": new makerjs.paths.Line([xi-h, yi+w/2], [xi-h1+d/2,yi+w/2]),
                  "HolesLf":new makerjs.paths.Arc([xi-h1+d/2,yi+w/2], [xi-h1-d/2,yi+w/2], d/2,false,true),
                  "HolesRt":new makerjs.paths.Arc([xi-h1-d/2,yi+w/2], [xi-h1+d/2,yi+w/2], d/2,false,true),
                  "SlotLineRt": new makerjs.paths.Line([xi-h1+d/2,yi+w/2], [xi-h, yi+w/2]),
                  "BottomLineRt": new makerjs.paths.Line([xi-h, yi+w/2], [xi-h, yi+w]),
                  "RightLine": new makerjs.paths.Line([xi-h, yi+w], [xi, yi+w]),
                  "ExLine": new makerjs.paths.Line([xi, yi+w], [xi+cutLine, yi+w]),
             }
              };
          }
} 
  
var fillet1 = makerjs.path.fillet(myCopperClipGapH.paths.LeftLine, myCopperClipGapH.paths.BottomLine, r);
var fillet2 = makerjs.path.fillet(myCopperClipGapH.paths.BottomLine, myCopperClipGapH.paths.RightLine, r);
myCopperClipGapH.paths.fillet1 = fillet1;
myCopperClipGapH.paths.fillet2 = fillet2;
var fillet11 = makerjs.path.fillet(myCopperClipGapHWaterCut.paths.LeftLine, myCopperClipGapHWaterCut.paths.BottomLineLf, r);

var fillet12 = makerjs.path.fillet(myCopperClipGapHWaterCut.paths.BottomLineLf, myCopperClipGapHWaterCut.paths.SlotLineLf, cutFilletRadius);
var fillet13 = makerjs.path.fillet(myCopperClipGapHWaterCut.paths.SlotLineLf, myCopperClipGapHWaterCut.paths.HolesLf, cutFilletRadius);
var fillet14 = makerjs.path.fillet(myCopperClipGapHWaterCut.paths.HolesRt, myCopperClipGapHWaterCut.paths.SlotLineRt, cutFilletRadius);
var fillet15 = makerjs.path.fillet(myCopperClipGapHWaterCut.paths.SlotLineRt, myCopperClipGapHWaterCut.paths.BottomLineRt, cutFilletRadius);

var fillet16 = makerjs.path.fillet(myCopperClipGapHWaterCut.paths.BottomLineRt, myCopperClipGapHWaterCut.paths.RightLine, r);
myCopperClipGapHWaterCut.paths.fillet11 = fillet11;
myCopperClipGapHWaterCut.paths.fillet12 = fillet12;
myCopperClipGapHWaterCut.paths.fillet13 = fillet13;
myCopperClipGapHWaterCut.paths.fillet14 = fillet14;
myCopperClipGapHWaterCut.paths.fillet15 = fillet15;
myCopperClipGapHWaterCut.paths.fillet16 = fillet16;
  return [myCopperClipGapH,myCopperClipGapHWaterCut];
};
// 矩形等去角标记 连线函数      
function creatmyCopperClipGapHMark(outParam, area, param, inputParam, fixedParam, OffsetParam, zoom) {
  console.log("是否调用此函数creatCornerMark()");
  console.log("是否调用此函数param", param);
  console.log("是否调用此函数outParam", outParam);
  console.log("是否调用此函数inputParam", inputParam);
  console.log("是否调用此函数OffsetParam", OffsetParam);
  var R=inputParam.R,W=inputParam.W,H1=inputParam.H1,H=inputParam.H,D=inputParam.D,X=inputParam.X,Y=inputParam.Y, myZoom = zoom * 1,
  xa = param.xa, ya = param.ya, xb = param.xb, 
  yb = param.yb, xc = param.xc, 
  xd = param.xd, yd = param.yd, xf = param.xf, yf = param.yf, 
  yc = param.yc, xg = param.xg, yg = param.yg, 
  xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi,
  x = param.x0, r = param.r, rd = param.rd,w = param.w,h1 = param.h1, h = param.h,d = param.d,
//   x0,rd,r,w,w1,h,d 
        glassW = outParam.glassW, glassH = outParam.glassH,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
        markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
        w= W*1*myZoom,
      h= H*1*myZoom,
      d= D*1*myZoom,
      h1= H1*1*myZoom,
      r=R*1*myZoom,
      rd=r/Math.sqrt(2),
      hd=r-rd,
        x0 = X*1*myZoom,
        y0 = Y*1*myZoom;
        if(d!==0){
         var TxtD="∮"+d;
        }
        if(r!==0){
         var TxtR="R="+R;
        }
        if(h!==0){
         var TxtH=H;
        }
        if(w!==0){
         var TxtW=W;
        }
        if(h1!==0){
         var TxtH1=H1;
        }
        if(x0!==0){          
        var TxtX=X;
        }
        if(y0!==0){          
         var TxtY=Y;
        }
if(glassW*1<glassH * 1){
            console.log("长边在X轴￥￥￥￥￥");
 if (area == "A") {
                  var myCopperClipAMakerW = {
                        paths: {
                              "WALine0": new makerjs.paths.Line([xa+0,ya+0+markShift], [xa+w, ya+0+markShift]),
                              "WALine1": new makerjs.paths.Line([xa+w,ya+0], [xa+w, ya+markShiftFour]),
                        }
                  };
                  var myCopperClipAMakerR = {
                        paths: {
                               "RALine0": new makerjs.paths.Line([xa+w-r,ya-h+r], [xa+w-r+rd,ya-h+r-rd]),
                              }
                  };
                  var myCopperClipAMakerX = {
                        paths: {
                              "XALine0": new makerjs.paths.Line([xa+0,ya+0], [xa+0, ya+markShiftFour]),
                              "XALine1": new makerjs.paths.Line([xa-x0,ya+0], [xa-x0, ya+markShiftFour]),
                              "XALine2": new makerjs.paths.Line([xa-x0,ya+0+markShiftTwo], [xa+0, ya+0+markShiftTwo]),
                        }
                  };
                  var myCopperClipAMakerH = {
                        paths: {
                           "HALine0": new makerjs.paths.Line([xa+0,ya-h], [xa+0-markShiftFour, ya-h]),
                           "HALine1": new makerjs.paths.Line([xa+0-markShift,ya-h], [xa+0-markShift, ya+0]),
                          // "WALine2": new makerjs.paths.Line([xa, ya+ markShiftTwo], [xa+w, ya + markShiftTwo]),
                        }
                  };
                  var myCopperClipAMakerH1 = {
                        paths: {
                           "H1ALine0": new makerjs.paths.Line([xa+w,ya-h1], [xa+w+markShiftFour+markShift, ya-h1]),
                           "H1ALine1":new makerjs.paths.Line([xa+w+markShiftFour,ya-h1], [xa+w+markShiftFour, ya+0]),
                          // "W1ALine2": new makerjs.paths.Line([xa, ya+ markShiftTwo], [xa+w, ya + markShiftTwo]),
                        }
                  };
                  var myCopperClipAMakerD = {
                        paths: {
                           "DALine0": new makerjs.paths.Line([xa+w/2,ya-h1], [xa+w/2+0+d, ya+0-h1-d]),
                          
                        }
                  };
                    makerjs.model.addCaption(myCopperClipAMakerW, TxtW, [xa+0,ya+0+markShiftThree], [xa+w, ya+0+markShiftThree]);//W文字标注
                    makerjs.model.addCaption(myCopperClipAMakerX, TxtX, [xa-x0,ya+0+markShiftFour], [xa+0, ya+0+markShiftFour]);//X文字标注
                    makerjs.model.addCaption(myCopperClipAMakerR, TxtR,  [xa+w-r+markHolesOneD,ya-h+r+r-markHolesOneD], [xa+w-r+rd+r+markHolesOneD, ya-h+r-rd-r-markHolesOneD]);//R文字标注  
                    makerjs.model.addCaption(myCopperClipAMakerH, TxtH, [xa+0-markShiftFour,ya-h], [xa+0-markShiftFour, ya+0]);//H文字标注    
                    makerjs.model.addCaption(myCopperClipAMakerH1, TxtH1,[xa+w+markShiftFour+markShift,ya-h1], [xa+w+markShiftFour+markShift, ya+0]);//H1文字标注    
                    makerjs.model.addCaption(myCopperClipAMakerD, TxtD, [xa+w/2,ya-h1],[xa+w/2+0+d+markHolesOneD, ya-h1+0-d-markHolesOneD]);//D文字标注  
                    var markers = [myCopperClipAMakerH,myCopperClipAMakerX,myCopperClipAMakerR,myCopperClipAMakerW,myCopperClipAMakerH1,myCopperClipAMakerD]
} else if (area == "B") {
                  var myCopperClipBMakerW = {
                        paths: {
                              "WALine0": new makerjs.paths.Line([xb-w/2,yb+0+markShift], [xb+w/2, yb+0+markShift]),
                              "WALine1": new makerjs.paths.Line([xb+w/2,yb+0], [xb+w/2, yb+markShiftFour]),
                        }
                  };
                  var myCopperClipBMakerR = {
                        paths: {
                               "RALine0": new makerjs.paths.Line([xb+w/2-r,yb-h+r], [xb+w/2-r+rd,yb-h+r-rd]),
                              }
                  };
                  var myCopperClipBMakerX = {
                        paths: {
                              "XALine0": new makerjs.paths.Line([xb-w/2,yb+0], [xb-w/2, yb+markShiftFour]),
                              "XALine1": new makerjs.paths.Line([xb-x0-w/2,yb+0], [xb-x0-w/2, yb+markShiftFour]),
                              "XALine2": new makerjs.paths.Line([xb-x0-w/2,yb+0+markShiftTwo], [xb-w/2, yb+0+markShiftTwo]),
                        }
                  };
                  var myCopperClipBMakerH = {
                        paths: {
                           "HALine0": new makerjs.paths.Line([xb-w/2,yb-h], [xb-w/2-markShiftFour, yb-h]),
                           "HALine1": new makerjs.paths.Line([xb-w/2-markShift,yb-h], [xb-w/2-markShift, yb+0]),
                          // "WALine2": new makerjs.paths.Line([xb, yb+ markShiftTwo], [xb+w, yb + markShiftTwo]),
                        }
                  };
                  var myCopperClipBMakerH1 = {
                        paths: {
                           "H1ALine0": new makerjs.paths.Line([xb+w/2,yb-h1], [xb+w/2+markShiftFour+markShift, yb-h1]),
                           "H1ALine1":new makerjs.paths.Line([xb+w/2+markShiftFour,yb-h1], [xb+w/2+markShiftFour, yb+0]),
                          // "W1ALine2": new makerjs.paths.Line([xb, yb+ markShiftTwo], [xb+w, yb + markShiftTwo]),
                        }
                  };
                  var myCopperClipBMakerD = {
                        paths: {
                           "DALine0": new makerjs.paths.Line([xb,yb-h1], [xb+d, yb+0-h1-d]),
                          
                        }
                  };
                    makerjs.model.addCaption(myCopperClipBMakerW, TxtW, [xb-w/2,yb+0+markShiftThree], [xb+w/2, yb+0+markShiftThree]);//W文字标注
                    makerjs.model.addCaption(myCopperClipBMakerX, TxtX, [xb-x0-w/2,yb+0+markShiftFour], [xb-w/2, yb+0+markShiftFour]);//X文字标注
                    makerjs.model.addCaption(myCopperClipBMakerR, TxtR,  [xb+w/2-r+markHolesOneD,yb-h+r+r-markHolesOneD], [xb+w/2-r+rd+r+markHolesOneD, yb-h+r-rd-r-markHolesOneD]);//R文字标注  
                    makerjs.model.addCaption(myCopperClipBMakerH, TxtH, [xb-w/2-markShiftFour,yb-h], [xb-w/2-markShiftFour, yb+0]);//H文字标注    
                    makerjs.model.addCaption(myCopperClipBMakerH1, TxtH1,[xb+w/2+markShiftFour+markShift,yb-h1], [xb+w/2+markShiftFour+markShift, yb+0]);//H1文字标注    
                    makerjs.model.addCaption(myCopperClipBMakerD, TxtD, [xb+d,yb-h1-d],[xb+d+markHolesOneD, yb-h1+0-d-markHolesOneD]);//D文字标注  
                    var markers = [myCopperClipBMakerH,myCopperClipBMakerX,myCopperClipBMakerR,myCopperClipBMakerW,myCopperClipBMakerH1,myCopperClipBMakerD]
} else if (area == "C") {
                  var myCopperClipCMakerW = {
                        paths: {
                              "WALine0": new makerjs.paths.Line([xc-0,yc+0+markShift], [xc-w, yc+0+markShift]),
                              "WALine1": new makerjs.paths.Line([xc-w,yc+0], [xc-w, yc+markShiftFour]),
                        }
                  };
                  var myCopperClipCMakerR = {
                        paths: {
                               "RALine0": new makerjs.paths.Line([xc-w+r,yc-h+r], [xc-w+r-rd,yc-h+r-rd]),
                              }
                  };
                  var myCopperClipCMakerX = {
                        paths: {
                              "XALine0": new makerjs.paths.Line([xc-0,yc+0], [xc-0, yc+markShiftFour]),
                              "XALine1": new makerjs.paths.Line([xc+x0,yc+0], [xc+x0, yc+markShiftFour]),
                              "XALine2": new makerjs.paths.Line([xc+x0,yc+0+markShiftTwo], [xc-0, yc+0+markShiftTwo]),
                        }
                  };
                  var myCopperClipCMakerH = {
                        paths: {
                           "HALine0": new makerjs.paths.Line([xc,yc-h], [xc+markShiftFour, yc-h]),
                           "HALine1": new makerjs.paths.Line([xc+markShift,yc-h], [xc+markShift, yc+0]),
                          // "WALine2": new makerjs.paths.Line([xc, yc+ markShiftTwo], [xc+w, yc + markShiftTwo]),
                        }
                  };
                  var myCopperClipCMakerH1 = {
                        paths: {
                           "H1ALine0": new makerjs.paths.Line([xc-w,yc-h1], [xc-w-markShiftFour-markShift, yc-h1]),
                           "H1ALine1":new makerjs.paths.Line([xc-w-markShiftFour,yc-h1], [xc-w-markShiftFour, yc+0]),
                          // "W1ALine2": new makerjs.paths.Line([xc, yc+ markShiftTwo], [xc+w, yc + markShiftTwo]),
                        }
                  };
                  var myCopperClipCMakerD = {
                        paths: {
                           "DALine0": new makerjs.paths.Line([xc-w/2,yc-h1], [xc-w/2+d, yc+0-h1-d]),
                          
                        }
                  };
                    makerjs.model.addCaption(myCopperClipCMakerW, TxtW, [xc-w, yc+0+markShiftThree], [xc,yc+0+markShiftThree]);//W文字标注
                    makerjs.model.addCaption(myCopperClipCMakerX, TxtX, [xc, yc+0+markShiftFour], [xc+x0,yc+0+markShiftFour]);//X文字标注
                    makerjs.model.addCaption(myCopperClipCMakerR, TxtR, [xc-w+r-rd-r-markHolesOneD, yc-h+r-rd-r-markHolesOneD],[xc-w+r-markHolesOneD,yc-h+r+r-markHolesOneD]);//R文字标注  
                    makerjs.model.addCaption(myCopperClipCMakerH, TxtH, [xc+markShiftFour,yc-h], [xc+markShiftFour, yc+0]);//H文字标注    
                    makerjs.model.addCaption(myCopperClipCMakerH1, TxtH1,[xc-w-markShiftFour-markShift,yc-h1], [xc-w-markShiftFour-markShift, yc+0]);//H1文字标注    
                    makerjs.model.addCaption(myCopperClipCMakerD, TxtD, [xc-w/2+d,yc-h1-d],[xc-w/2+d+markHolesOneD, yc-h1+0-d-markHolesOneD]);//D文字标注  
              var markers = [myCopperClipCMakerH,myCopperClipCMakerX,myCopperClipCMakerR,myCopperClipCMakerW,myCopperClipCMakerH1,myCopperClipCMakerD]
} else if (area == "G") {
                  var myCopperClipGMakerW = {
                        paths: {
                              "WALine0": new makerjs.paths.Line([xg,yg-markShiftTwo], [xg+w, yg-markShiftTwo]),
                              "WALine1": new makerjs.paths.Line([xg+w,yg], [xg+w, yg-markShiftFour]),
                        }
                  };
                  var myCopperClipGMakerR = {
                        paths: {
                               "RALine0": new makerjs.paths.Line([xg+w-r,yg+h-r], [xg+w-r+rd,yg+h-r+rd]),
                              }
                  };
                  var myCopperClipGMakerX = {
                        paths: {
                              "XALine0": new makerjs.paths.Line([xg,yg], [xg, yg-markShiftFour]),
                              "XALine1": new makerjs.paths.Line([xg-x0,yg], [xg-x0, yg-markShiftFour]),
                              "XALine2": new makerjs.paths.Line([xg-x0,yg-markShiftTwo], [xg, yg-markShiftTwo]),
                        }
                  };
                  var myCopperClipGMakerH = {
                        paths: {
                           "HALine0": new makerjs.paths.Line([xg,yg+h], [xg-markShiftFour, yg+h]),
                           "HALine1": new makerjs.paths.Line([xg-markShift,yg+h], [xg-markShift, yg]),
                        }
                  };
                  var myCopperClipGMakerH1 = {
                        paths: {
                           "H1ALine0": new makerjs.paths.Line([xg+w,yg+h1], [xg+w+markShiftFour+markShift, yg+h1]),
                           "H1ALine1":new makerjs.paths.Line([xg+w+markShiftFour,yg+h1], [xg+w+markShiftFour, yg]),
                        }
                  };
                  var myCopperClipGMakerD = {
                        paths: {
                           "DALine0": new makerjs.paths.Line([xg+w/2,yg+h1], [xg+w/2+d, yg+h1+d]),
                          
                        }
                  };
                    makerjs.model.addCaption(myCopperClipGMakerW, TxtW, [xg,yg-markShiftFour], [xg+w, yg-markShiftFour]);//W文字标注
                    makerjs.model.addCaption(myCopperClipGMakerX, TxtX, [xg-x0,yg-markShiftFour], [xg, yg-markShiftFour]);//X文字标注
                    makerjs.model.addCaption(myCopperClipGMakerR, TxtR,  [xg+w-r+markHolesOneD,yg+h-r-r+markHolesOneD], [xg+w-r+rd+r+markHolesOneD, yg+h-r+rd+r+markHolesOneD]);//R文字标注  
                    makerjs.model.addCaption(myCopperClipGMakerH, TxtH, [xg-markShiftFour, yg], [xg-markShiftFour,yg+h]);//H文字标注    
                    makerjs.model.addCaption(myCopperClipGMakerH1, TxtH1, [xg+w+markShiftFour+markShift, yg],[xg+w+markShiftFour+markShift,yg+h1]);//H1文字标注    
                    makerjs.model.addCaption(myCopperClipGMakerD, TxtD, [xg+w/2,yg+h1],[xg+w/2+d+markHolesOneD, yg+h1+d+markHolesOneD]);//D文字标注  
                    var markers = [myCopperClipGMakerH,myCopperClipGMakerX,myCopperClipGMakerR,myCopperClipGMakerW,myCopperClipGMakerH1,myCopperClipGMakerD]
} else if (area == "H") {
                  var myCopperClipHMakerW = {
                        paths: {
                              "WALine0": new makerjs.paths.Line([xh-w/2,yh+markShift], [xh+w/2, yh+markShift]),
                              //"WALine1": new makerjs.paths.Line([xh+w,yh], [xh+w, yh-markShiftFour]),
                        }
                  };
                  var myCopperClipHMakerR = {
                        paths: {
                               "RALine0": new makerjs.paths.Line([xh+w/2-r,yh+h-r], [xh+w/2-r+rd,yh+h-r+rd]),
                              }
                  };
                  var myCopperClipHMakerX = {
                        paths: {
                              // "XALine0": new makerjs.paths.Line([xh+0,yh], [xh+0, yh-markShiftFour]),
                              // "XALine1": new makerjs.paths.Line([xh-x0,yh], [xh-x0, yh-markShiftFour]),
                              // "XALine2": new makerjs.paths.Line([xh-x0,yh-markShiftTwo], [xh+0, yh-markShiftTwo]),
                        }
                  };
                  var myCopperClipHMakerH = {
                        paths: {
                           "HALine0": new makerjs.paths.Line([xh-w/2,yh+h], [xh-w/2-markShiftFour, yh+h]),
                           "HALine1": new makerjs.paths.Line([xh-w/2-markShift,yh+h], [xh-w/2-markShift, yh+0]),
                        }
                  };
                  var myCopperClipHMakerH1 = {
                        paths: {
                           "H1ALine0": new makerjs.paths.Line([xh+w/2,yh+h1], [xh+w/2+markShiftFour+markShift, yh+h1]),
                           "H1ALine1":new makerjs.paths.Line([xh+w/2+markShiftFour,yh+h1], [xh+w/2+markShiftFour, yh+0]),
                        }
                  };
                  var myCopperClipHMakerD = {
                        paths: {
                           "DALine0": new makerjs.paths.Line([xh,yh+h1], [xh+d, yh+h1+d]),
                          
                        }
                  };
                    makerjs.model.addCaption(myCopperClipHMakerW, TxtW, [xh-w/2,yh+markShiftThree], [xh+w/2, yh+markShiftThree]);//W文字标注
                    makerjs.model.addCaption(myCopperClipHMakerX, TxtX, [xh-x0-w/2,yh-markShiftFour], [xh-w/2, yh-markShiftFour]);//X文字标注
                    makerjs.model.addCaption(myCopperClipHMakerR, TxtR,  [xh+w/2-r+markHolesOneD,yh+h-r-r+markHolesOneD], [xh+w/2-r+rd+r+markHolesOneD, yh+h-r+rd+r+markHolesOneD]);//R文字标注  
                    makerjs.model.addCaption(myCopperClipHMakerH, TxtH, [xh-w/2-markShiftFour, yh], [xh-w/2-markShiftFour,yh+h]);//H文字标注    
                    makerjs.model.addCaption(myCopperClipHMakerH1, TxtH1, [xh+w/2+markShiftFour+markShift, yh],[xh+w/2+markShiftFour+markShift,yh+h1]);//H1文字标注    
                    makerjs.model.addCaption(myCopperClipHMakerD, TxtD, [xh,yh+h1],[xh+d+markHolesOneD, yh+h1+d+markHolesOneD]);//D文字标注  
                    var markers = [myCopperClipHMakerH,myCopperClipHMakerX,myCopperClipHMakerR,myCopperClipHMakerW,myCopperClipHMakerH1,myCopperClipHMakerD]
} else if (area == "I") {
                  var myCopperClipIMakerW = {
                        paths: {
                              "WALine0": new makerjs.paths.Line([xi,yi-markShiftTwo], [xi-w, yi-markShiftTwo]),
                              "WALine1": new makerjs.paths.Line([xi-w,yi], [xi-w, yi-markShiftFour]),
                        }
                  };
                  var myCopperClipIMakerR = {
                        paths: {
                               "RALine0": new makerjs.paths.Line([xi-w+r,yi+h-r], [xi-w+r-rd,yi+h-r+rd]),
                              }
                  };
                  var myCopperClipIMakerX = {
                        paths: {
                              "XALine0": new makerjs.paths.Line([xi-0,yi], [xi-0, yi-markShiftFour]),
                              "XALine1": new makerjs.paths.Line([xi+x0,yi], [xi+x0, yi-markShiftFour]),
                              "XALine2": new makerjs.paths.Line([xi+x0,yi-markShiftTwo], [xi-0, yi-markShiftTwo]),
                        }
                  };
                  var myCopperClipIMakerH = {
                        paths: {
                           "HALine0": new makerjs.paths.Line([xi,yi+h], [xi+markShiftFour, yi+h]),
                           "HALine1": new makerjs.paths.Line([xi+markShift,yi+h], [xi+markShift, yi]),
                        }
                  };
                  var myCopperClipIMakerH1 = {
                        paths: {
                           "H1ALine0": new makerjs.paths.Line([xi-w,yi+h1], [xi-w-markShiftFour-markShift, yi+h1]),
                           "H1ALine1":new makerjs.paths.Line([xi-w-markShiftFour,yi+h1], [xi-w-markShiftFour, yi]),
                        }
                  };
                  var myCopperClipIMakerD = {
                        paths: {
                           "DALine0": new makerjs.paths.Line([xi-w/2,yi+h1], [xi-w/2+d, yi+h1+d]),
                          
                        }
                  };
                    makerjs.model.addCaption(myCopperClipIMakerW, TxtW, [xi-w, yi-markShiftFour], [xi,yi-markShiftFour]);//W文字标注
                    makerjs.model.addCaption(myCopperClipIMakerX, TxtX, [xi, yi-markShiftFour], [xi+x0,yi-markShiftFour]);//X文字标注
                    makerjs.model.addCaption(myCopperClipIMakerR, TxtR, [xi-w+r-rd-r-markHolesOneD, yi+h-r+rd+r+markHolesOneD],[xi-w+r-markHolesOneD,yi+h-r-r+markHolesOneD]);//R文字标注  
                    makerjs.model.addCaption(myCopperClipIMakerH, TxtH, [xi+markShiftFour, yi], [xi+markShiftFour,yi+h]);//H文字标注    
                    makerjs.model.addCaption(myCopperClipIMakerH1, TxtH1, [xi-w-markShiftFour-markShift, yi],[xi-w-markShiftFour-markShift,yi+h1]);//H1文字标注    
                    makerjs.model.addCaption(myCopperClipIMakerD, TxtD, [xi-w/2+d,yi+h1+d],[xi-w/2+d+markHolesOneD, yi+h1+d+markHolesOneD]);//D文字标注  
              var markers = [myCopperClipIMakerH,myCopperClipIMakerX,myCopperClipIMakerR,myCopperClipIMakerW,myCopperClipIMakerH1,myCopperClipIMakerD]
}     
 }else{
            console.log("短边在X轴￥￥￥￥￥");
if (area == "A") {
                  var myCopperClipAMakerW = {
                        paths: {
                              "WALine0": new makerjs.paths.Line([xa+markShift,ya-w], [xa+markShift, ya]),
                              // "WALine1": new makerjs.paths.Line([xa+w,ya+0], [xa+w, ya+markShiftFour]),
                        }
                  };
                  var myCopperClipAMakerR = {
                        paths: {
                               "RALine0": new makerjs.paths.Line([xa+h-hd,ya-hd], [xa+h-r-markShiftTwo,ya-hd-r-markShiftTwo]),
                              }
                  };
                  var myCopperClipAMakerY = {
                        paths: {
                              "YALine0": new makerjs.paths.Line([xa - markShiftTwo, ya], [xa-markShiftTwo, ya +y0]),
                                    "YALine1": new makerjs.paths.Line([xa - markShiftFour, ya+y0], [xa, ya + y0]),
                                    "YALine2": new makerjs.paths.Line([xa - markShiftFour, ya], [xa, ya]),
                        }
                  };
                  var myCopperClipAMakerH = {
                        paths: {
                              "HALine0": new makerjs.paths.Line([xa,ya-w-markShiftTwo],[xa+h,ya-w-markShiftTwo]),
                              "HALine1": new makerjs.paths.Line([xa+h,ya-w-markShiftFour],[xa+h,ya-w]),
                        }
                  };
                  var myCopperClipAMakerH1 = {
                        paths: {
                           "H1ALine0": new makerjs.paths.Line([xa+h1,ya-w/2], [xa+h1, ya+markShiftFour]),
                           "H1ALine1":new makerjs.paths.Line([xa,ya+markShiftTwo], [xa+h1, ya+markShiftTwo]),
                          // "W1ALine2": new makerjs.paths.Line([xa, ya+ markShiftTwo], [xa+w, ya + markShiftTwo]),
                        }
                  };
                  var myCopperClipAMakerD = {
                        paths: {
                           "DALine0": new makerjs.paths.Line([xa+h1,ya-w/2], [xa+h1+d+markShift,ya-w/2+d+markShift]),
                          
                        }
                  };
                    makerjs.model.addCaption(myCopperClipAMakerW, TxtW,[xa+ markShiftThree, ya-w], [xa+markShiftThree, ya]);//W文字标注
                    makerjs.model.addCaption(myCopperClipAMakerY, TxtY,[xa - markShiftFour, ya], [xa-markShiftFour, ya +y0]);//X文字标注
                    makerjs.model.addCaption(myCopperClipAMakerR, TxtR,[xa+h-r-markShiftFour,ya-hd-r-markShiftFour], [xa+h-r-markShiftTwo,ya-hd-r-markShiftFour]);//R文字标注  
                    makerjs.model.addCaption(myCopperClipAMakerH, TxtH, [xa,ya-w-markShiftFour],[xa+h,ya-w-markShiftFour]);//H文字标注    
                    makerjs.model.addCaption(myCopperClipAMakerH1, TxtH1,[xa,ya+markShiftFour], [xa+h1, ya+markShiftFour]);//H1文字标注    
                    makerjs.model.addCaption(myCopperClipAMakerD, TxtD, [xa+h1+d+markShift,ya-w/2+d+markShift],[xa+h1+d+markShift+markShiftFour,ya-w/2+d+markShift]);//D文字标注  
                    var markers = [myCopperClipAMakerH,myCopperClipAMakerY,myCopperClipAMakerR,myCopperClipAMakerW,myCopperClipAMakerH1,myCopperClipAMakerD]
} else if (area == "D") {
      var myCopperClipDMakerH = {
            paths: {
                  "HDLine0": new makerjs.paths.Line([xd,yd-w/2-markShiftTwo],[xd+h,yd-w/2-markShiftTwo]),
                  "HDLine1": new makerjs.paths.Line([xd+h,yd-w/2-markShiftFour],[xd+h,yd-w/2]),
            }
      };
      var myCopperClipDMakerR = {
            paths: {
                   "RDLine0": new makerjs.paths.Line([xd+h-hd,yd-hd+w/2], [xd+h-r-markShiftTwo,yd-hd-r-markShiftTwo+w/2]),
                  }
      };
      var myCopperClipDMakerY = {
            paths: {
                  // "YDLine0": new makerjs.paths.Line([xd - markShiftTwo, yd+w/2], [xd-markShiftTwo, yd +y0+w/2]),
                  // "YDLine1": new makerjs.paths.Line([xd - markShiftFour, yd+y0+w/2], [xd, yd + y0+w/2]),
                  // "YDLine2": new makerjs.paths.Line([xd - markShiftFour, yd+w/2], [xd, yd+w/2]),
            }
      };
      var myCopperClipDMakerW = {
            paths: {
            //    "WDLine0": new makerjs.paths.Line([xd, yd], [xd, yd + markShiftFour]),
            //    "WDLine1": new makerjs.paths.Line([xd+w, yd], [xd+w, yd + markShiftFour]),
               "WDLine2": new makerjs.paths.Line([xd+ markShift, yd-w/2], [xd+markShift, yd+w/2]),
            }
      };
    var myCopperClipDMakerH1 = {
                        paths: {
                              "H1ALine0": new makerjs.paths.Line([xd+h1,yd], [xd+h1, yd+markShiftFour+w/2]),
                              "H1ALine1":new makerjs.paths.Line([xd,yd+markShiftTwo+w/2], [xd+h1, yd+markShiftTwo+w/2]),
                        }
      };
     var myCopperClipDMakerD = {
                        paths: {
                           "DALine0": new makerjs.paths.Line([xd+h1,yd], [xd+h1+d+markShift,yd+d+markShift]),
                          
                        }
        };
        makerjs.model.addCaption(myCopperClipDMakerH, TxtH, [xd,yd-w/2-markShiftFour],[xd+h,yd-w/2-markShiftFour]);//H文字标注
        makerjs.model.addCaption(myCopperClipDMakerY, TxtY, [xd - markShiftFour, yd+w/2], [xd-markShiftFour, yd +y0+w/2]);//X文字标注
        makerjs.model.addCaption(myCopperClipDMakerR, TxtR, [xd+h-r-markShiftFour,yd-hd-r-markShiftFour+w/2], [xd+h-r-markShiftTwo,yd-hd-r-markShiftFour+w/2]);//R文字标注  
        makerjs.model.addCaption(myCopperClipDMakerW, TxtW, [xd+ markShiftThree, yd-w/2], [xd+markShiftThree, yd+w/2]);//W文字标注  
       makerjs.model.addCaption(myCopperClipDMakerH1, TxtH1,[xd,yd+markShiftFour+w/2], [xd+h1, yd+markShiftFour+w/2]);//H1文字标注    
         makerjs.model.addCaption(myCopperClipDMakerD, TxtD,  [xd+h1+d+markShift,yd+d+markShift],[xd+h1+d+markShift+markShiftFour,yd+d+markShift]);//D文字标注  
         var markers = [myCopperClipDMakerH,myCopperClipDMakerY,myCopperClipDMakerR,myCopperClipDMakerW,myCopperClipDMakerH1,myCopperClipDMakerD]
} else if (area == "C") {
      var myCopperClipCMakerW = {
            paths: {
                  "WCLine0": new makerjs.paths.Line([xc-markShift,yc-w], [xc-markShift, yc]),
                  // "WCLine1": new makerjs.paths.Line([xc+w,yc+0], [xc+w, yc+markShiftFour]),
            }
      };
      var myCopperClipCMakerR = {
            paths: {
                   "RCLine0": new makerjs.paths.Line([xc-h+hd,yc-hd], [xc-h+r+markShiftTwo,yc-hd-r-markShiftTwo]),
                  }
      };
      var myCopperClipCMakerY = {
            paths: {
                  "YCLine0": new makerjs.paths.Line([xc + markShiftTwo, yc], [xc+markShiftTwo, yc +y0]),
                        "YCLine1": new makerjs.paths.Line([xc + markShiftFour, yc+y0], [xc, yc + y0]),
                        "YCLine2": new makerjs.paths.Line([xc + markShiftFour, yc], [xc, yc]),
            }
      };
      var myCopperClipCMakerH = {
            paths: {
                  "HCLine0": new makerjs.paths.Line([xc,yc-w-markShiftTwo],[xc-h,yc-w-markShiftTwo]),
                  "HCLine1": new makerjs.paths.Line([xc-h,yc-w-markShiftFour],[xc-h,yc-w]),
            }
      };
      var myCopperClipCMakerH1 = {
            paths: {
               "H1CLine0": new makerjs.paths.Line([xc-h1,yc-w/2], [xc-h1, yc+markShiftFour]),
               "H1CLine1":new makerjs.paths.Line([xc,yc+markShiftTwo], [xc-h1, yc+markShiftTwo]),
              // "W1CLine2": new makerjs.paths.Line([xc, yc+ markShiftTwo], [xc+w, yc + markShiftTwo]),
            }
      };
      var myCopperClipCMakerD = {
            paths: {
               "DCLine0": new makerjs.paths.Line([xc-h1,yc-w/2], [xc-h1-d-markShift,yc-w/2+d+markShift]),
              
            }
      };
        makerjs.model.addCaption(myCopperClipCMakerW, TxtW,[xc- markShiftThree, yc-w], [xc-markShiftThree, yc]);//W文字标注
        makerjs.model.addCaption(myCopperClipCMakerY, TxtY,[xc + markShiftFour, yc], [xc+markShiftFour, yc +y0]);//X文字标注
        makerjs.model.addCaption(myCopperClipCMakerR, TxtR, [xc-h+r+markShiftTwo,yc-hd-r-markShiftFour],[xc-h+r+markShiftFour,yc-hd-r-markShiftFour]);//R文字标注  
        makerjs.model.addCaption(myCopperClipCMakerH, TxtH, [xc-h,yc-w-markShiftFour],[xc,yc-w-markShiftFour]);//H文字标注    
        makerjs.model.addCaption(myCopperClipCMakerH1, TxtH1,[xc-h1,yc+markShiftFour], [xc, yc+markShiftFour]);//H1文字标注    
        makerjs.model.addCaption(myCopperClipCMakerD, TxtD,[xc-h1-d-markShift-markShiftFour,yc-w/2+d+markShift], [xc-h1-d-markShift,yc-w/2+d+markShift]);//D文字标注  
        var markers = [myCopperClipCMakerH,myCopperClipCMakerY,myCopperClipCMakerR,myCopperClipCMakerW,myCopperClipCMakerH1,myCopperClipCMakerD]
} else if (area == "G") {
      var myCopperClipGMakerW = {
            paths: {
                  "WGLine0": new makerjs.paths.Line([xg+markShift,yg+w], [xg+markShift, yg]),
                  // "WGLine1": new makerjs.paths.Line([xg+w,yg+0], [xg+w, yg+markShiftFour]),
            }
      };
      var myCopperClipGMakerR = {
            paths: {
                   "RGLine0": new makerjs.paths.Line([xg+h-hd,yg+hd], [xg+h-r-markShiftTwo,yg+hd+r+markShiftTwo]),
                  }
      };
      var myCopperClipGMakerY = {
            paths: {
                  "YGLine0": new makerjs.paths.Line([xg - markShiftTwo, yg], [xg-markShiftTwo, yg-y0]),
                        "YGLine1": new makerjs.paths.Line([xg - markShiftFour, yg-y0], [xg, yg - y0]),
                        "YGLine2": new makerjs.paths.Line([xg - markShiftFour, yg], [xg, yg]),
            }
      };
      var myCopperClipGMakerH = {
            paths: {
                  "HGLine0": new makerjs.paths.Line([xg,yg+w+markShiftTwo],[xg+h,yg+w+markShiftTwo]),
                  "HGLine1": new makerjs.paths.Line([xg+h,yg+w+markShiftFour],[xg+h,yg+w]),
            }
      };
      var myCopperClipGMakerH1 = {
            paths: {
               "H1GLine0": new makerjs.paths.Line([xg+h1,yg+w/2], [xg+h1, yg-markShiftFour]),
               "H1GLine1":new makerjs.paths.Line([xg,yg-markShiftTwo], [xg+h1, yg-markShiftTwo]),
              // "W1GLine2": new makerjs.paths.Line([xg, yg+ markShiftTwo], [xg+w, yg + markShiftTwo]),
            }
      };
      var myCopperClipGMakerD = {
            paths: {
               "DGLine0": new makerjs.paths.Line([xg+h1,yg+w/2], [xg+h1+d+markShift,yg+w/2-d-markShift]),
              
            }
      };
        makerjs.model.addCaption(myCopperClipGMakerW, TxtW,[xg+ markShiftThree, yg], [xg+markShiftThree, yg+w]);//W文字标注
        makerjs.model.addCaption(myCopperClipGMakerY, TxtY,[xg - markShiftFour, yg-y0], [xg-markShiftFour, yg]);//X文字标注
        makerjs.model.addCaption(myCopperClipGMakerR, TxtR,[xg+h-r-markShiftFour,yg+hd+r+markShiftFour], [xg+h-r-markShiftTwo,yg+hd+r+markShiftFour]);//R文字标注  
        makerjs.model.addCaption(myCopperClipGMakerH, TxtH, [xg,yg+w+markShiftFour],[xg+h,yg+w+markShiftFour]);//H文字标注    
        makerjs.model.addCaption(myCopperClipGMakerH1, TxtH1,[xg,yg-markShiftFour], [xg+h1, yg-markShiftFour]);//H1文字标注    
        makerjs.model.addCaption(myCopperClipGMakerD, TxtD, [xg+h1+d+markShift,yg+w/2-d-markShift],[xg+h1+d+markShift+markShiftFour,yg+w/2-d-markShift]);//D文字标注  
        var markers = [myCopperClipGMakerH,myCopperClipGMakerY,myCopperClipGMakerR,myCopperClipGMakerW,myCopperClipGMakerH1,myCopperClipGMakerD]
} else if (area == "F") {
      var myCopperClipFMakerW = {
            paths: {
                  "WFLine0": new makerjs.paths.Line([xf-markShift,yf-w/2], [xf-markShift, yf+w/2]),
                  // "WCLine1": new makerjs.paths.Line([xf+w,yf+0], [xf+w, yf+markShiftFour]),
            }
      };
      var myCopperClipFMakerR = {
            paths: {
                   "RFLine0": new makerjs.paths.Line([xf-h+hd,yf-hd+w/2], [xf-h+r+markShiftTwo,yf-hd-r-markShiftTwo+w/2]),
                  }
      };
      var myCopperClipFMakerY = {
            paths: {
                  // "YFLine0": new makerjs.paths.Line([xf + markShiftTwo, yf+w/2], [xf+markShiftTwo, yf +y0+w/2]),
                        // "YFLine1": new makerjs.paths.Line([xf + markShiftFour, yf+y0+w/2], [xf, yf + y0+w/2]),
                        // "YFLine2": new makerjs.paths.Line([xf + markShiftFour, yf+w/2], [xf, yf+w/2]),
            }
      };
      var myCopperClipFMakerH = {
            paths: {
                  "HFLine0": new makerjs.paths.Line([xf,yf-w/2-markShiftTwo],[xf-h,yf-w/2-markShiftTwo]),
                  "HFLine1": new makerjs.paths.Line([xf-h,yf-w/2-markShiftFour],[xf-h,yf-w/2]),
            }
      };
      var myCopperClipFMakerH1 = {
            paths: {
               "H1FLine0": new makerjs.paths.Line([xf-h1,yf], [xf-h1, yf+markShiftFour+w/2]),
               "H1FLine1":new makerjs.paths.Line([xf,yf+markShiftTwo+w/2], [xf-h1, yf+markShiftTwo+w/2]),
              // "W1CLine2": new makerjs.paths.Line([xf, yf+ markShiftTwo], [xf+w, yf + markShiftTwo]),
            }
      };
      var myCopperClipFMakerD = {
            paths: {
               "DFLine0": new makerjs.paths.Line([xf-h1,yf], [xf-h1-d-markShift,yf+d+markShift]),
              
            }
      };
        makerjs.model.addCaption(myCopperClipFMakerW, TxtW,[xf- markShiftThree, yf-w/2], [xf-markShiftThree, yf+w/2]);//W文字标注
        makerjs.model.addCaption(myCopperClipFMakerY, TxtY,[xf + markShiftFour, yf+w/2], [xf+markShiftFour, yf +y0+w/2]);//X文字标注
        makerjs.model.addCaption(myCopperClipFMakerR, TxtR, [xf-h+r+markShiftTwo,yf-hd-r-markShiftFour+w/2],[xf-h+r+markShiftFour,yf-hd-r-markShiftFour+w/2]);//R文字标注  
        makerjs.model.addCaption(myCopperClipFMakerH, TxtH, [xf-h,yf-w/2-markShiftFour],[xf,yf-w/2-markShiftFour]);//H文字标注    
        makerjs.model.addCaption(myCopperClipFMakerH1, TxtH1,[xf-h1,yf+markShiftFour+w/2], [xf, yf+markShiftFour+w/2]);//H1文字标注    
        makerjs.model.addCaption(myCopperClipFMakerD, TxtD,[xf-h1-d-markShift-markShiftFour,yf+d+markShift], [xf-h1-d-markShift,yf+d+markShift]);//D文字标注  
        var markers = [myCopperClipFMakerH,myCopperClipFMakerY,myCopperClipFMakerR,myCopperClipFMakerW,myCopperClipFMakerH1,myCopperClipFMakerD]
} else if (area == "I") {
      var myCopperClipIMakerW = {
            paths: {
                  "WILine0": new makerjs.paths.Line([xi-markShift,yi+w], [xi-markShift, yi]),
                  // "WILine1": new makerjs.paths.Line([xi+w,yi+0], [xi+w, yi+markShiftFour]),
            }
      };
      var myCopperClipIMakerR = {
            paths: {
                   "RILine0": new makerjs.paths.Line([xi-h+hd,yi+hd], [xi-h+r+markShiftTwo,yi+hd+r+markShiftTwo]),
                  }
      };
      var myCopperClipIMakerY = {
            paths: {
                  "YILine0": new makerjs.paths.Line([xi + markShiftTwo, yi], [xi+markShiftTwo, yi -y0]),
                        "YILine1": new makerjs.paths.Line([xi + markShiftFour, yi-y0], [xi, yi - y0]),
                        "YILine2": new makerjs.paths.Line([xi + markShiftFour, yi], [xi, yi]),
            }
      };
      var myCopperClipIMakerH = {
            paths: {
                  "HILine0": new makerjs.paths.Line([xi,yi+w+markShiftTwo],[xi-h,yi+w+markShiftTwo]),
                  "HILine1": new makerjs.paths.Line([xi-h,yi+w+markShiftFour],[xi-h,yi+w]),
            }
      };
      var myCopperClipIMakerH1 = {
            paths: {
               "H1ILine0": new makerjs.paths.Line([xi-h1,yi+w/2], [xi-h1, yi-markShiftFour]),
               "H1ILine1":new makerjs.paths.Line([xi,yi-markShiftTwo], [xi-h1, yi-markShiftTwo]),
              // "W1CLine2": new makerjs.paths.Line([xi, yi+ markShiftTwo], [xi+w, yi + markShiftTwo]),
            }
      };
      var myCopperClipIMakerD = {
            paths: {
               "DILine0": new makerjs.paths.Line([xi-h1,yi+w/2], [xi-h1-d-markShift,yi+w/2-d-markShift]),
              
            }
      };
        makerjs.model.addCaption(myCopperClipIMakerW, TxtW,[xi- markShiftThree, yi+w], [xi-markShiftThree, yi]);//W文字标注
        makerjs.model.addCaption(myCopperClipIMakerY, TxtY,[xi + markShiftFour, yi], [xi+markShiftFour, yi -y0]);//X文字标注
        makerjs.model.addCaption(myCopperClipIMakerR, TxtR, [xi-h+r+markShiftTwo,yi+hd+r+markShiftFour],[xi-h+r+markShiftFour,yi+hd+r+markShiftFour]);//R文字标注  
        makerjs.model.addCaption(myCopperClipIMakerH, TxtH, [xi-h,yi+w+markShiftFour],[xi,yi+w+markShiftFour]);//H文字标注    
        makerjs.model.addCaption(myCopperClipIMakerH1, TxtH1,[xi-h1,yi-markShiftFour], [xi, yi-markShiftFour]);//H1文字标注    
        makerjs.model.addCaption(myCopperClipIMakerD, TxtD,[xi-h1-d-markShift-markShiftFour,yi+w/2-d-markShift], [xi-h1-d-markShift,yi+w/2-d-markShift]);//D文字标注  
        var markers = [myCopperClipIMakerH,myCopperClipIMakerY,myCopperClipIMakerR,myCopperClipIMakerW,myCopperClipIMakerH1,myCopperClipIMakerD]
 }     
 }
  
  console.log("markers||||||||||||||||||=", markers)
  return markers;
};
// inputParam,model,myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function CopperClipGap(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut,cutLine,cutFilletRadius){

      var frame = outParam.shapeName;
      console.log("outParam==", outParam)
      console.log("model==", model)
      console.log("inputParam==", inputParam)
      console.log("outParam.shapeName==////////", outParam.shapeName)
      if (typeof (frame) == "undefined") {
            var R=inputParam.R,W=inputParam.W,H1=inputParam.H1,H=inputParam.H,D=inputParam.D,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
            plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = "Rectangle",
                  glassW = outParam.glassW, glassH = outParam.glassH,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
                  markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
                  markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,
                  w= W*1*myZoom,
                  h= H*1*myZoom,
                  d= D*1*myZoom,
                  h1= H1*1*myZoom,
                  r=R*1*myZoom,
                  rd=r/Math.sqrt(2),
                    x0 = X*1*myZoom,
                    y0 = Y*1*myZoom;
                    if(plate.models===undefined||plate.models===""){
                        console.log("1111111111111111");
                        plate.models={};
                                }        
                                if(cutPlate.models===undefined||cutPlate.models===""){
                                    console.log("22222222222");
                                    //cutPlate.models={};
                                    cutPlate.models={};
                                }
                                if(markers.models===undefined||markers.models===""){            
                                    console.log("333333333333");
                                    markers.models={};
                                }
                    /*
                    
               w= W*1,
                  h= H*1,
                  d= D*1,
                  w1= W1*1,
                  r=R*1,
                  rd=r/Math.sqrt(2),
                    x0 = X*1,
                    y0 = Y*1;
                    */
                    if(d!==0){
                     var TxtD="∮"+d;
                    }
                    if(r!==0){
                     var TxtR="R="+R;
                    }
                    if(h!==0){
                     var TxtH=H;
                    }
                    if(w!==0){
                     var TxtW=W;
                    }
                    if(h1!==0){
                     var TxtH1=H1;
                    }
                    if(x0!==0){          
                    var TxtX=X;
                    }
                    if(y0!==0){          
                     var TxtY=Y;
                    }
      } else {
            var R=inputParam.R,W=inputParam.W,H1=inputParam.H1,H=inputParam.H,D=inputParam.D,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
            plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = outParam.shapeName,
                  glassW = outParam.glassW, glassH = outParam.glassH,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
                  markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
                  markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,
                  w= W*1*myZoom,
                  h= H*1*myZoom,
                  d= D*1*myZoom,
                  h1= H1*1*myZoom,
                  r=R*1*myZoom,
                  rd=r/Math.sqrt(2),
                    x0 = X*1*myZoom,
                    y0 = Y*1*myZoom;
                    if(plate.models===undefined||plate.models===""){
                        console.log("1111111111111111");
                        plate.models={};
                                }        
                                if(cutPlate.models===undefined||cutPlate.models===""){
                                    console.log("22222222222");
                                    //cutPlate.models={};
                                    cutPlate.models={};
                                }
                                if(markers.models===undefined||markers.models===""){            
                                    console.log("333333333333");
                                    markers.models={};
                                }
                    if(d!==0){
                     var TxtD="∮"+d;
                    }
                    if(r!==0){
                     var TxtR="R="+R;
                    }
                    if(h!==0){
                     var TxtH=H;
                    }
                    if(w!==0){
                     var TxtW=W;
                    }
                    if(h1!==0){
                     var TxtH1=H1;
                    }
                    if(x0!==0){          
                    var TxtX=X;
                    }
                    if(y0!==0){          
                     var TxtY=Y;
                    }
      }
      if (frame == "Rectangle") {
            console.log("frame==undefined||||*****")
            //在A区域 计算孔的位置       
            var xa = x0, ya = glassH * 1 - y0,
                  //B区域//只有Y标注没有X标注 
                  xb = glassW * 1 / 2, yb = glassH * 1 - y0,
                  //C区域
                  xc = glassW * 1 - x0, yc = glassH * 1 - y0,
                  //D区域
  //只有X标注没有Y标注 
  xd=x0,yd=glassH * 1/2,
  //E区域
  //只有X标注没有Y标注 
  xe=glassW * 1/2,ye=glassH * 1/2,
  //F区域
  //只有X标注没有Y标注 
  xf=glassW * 1-x0,yf=glassH * 1/2,
                  //在G区域 计算孔的位置
                  xg = x0, yg = y0,
                  //在H区域 计算孔的位置
                  //只标注Y
                  xh = glassW * 1 / 2, yh = y0,
                  //在I区域 计算孔的位置
                  xi = glassW * 1 - x0, yi = y0;
            var OffsetParam = {};
      } else if (frame == "IsoscelesTrapezoid") {
    
      } else if (frame == "RightAngledTrapezoid") {d
    
      } else if (frame == "OtherTrapezoidsA") {
    
      } else if (frame == "OtherTrapezoidsB") {
    
      } else if (frame == "ParallelogramA") {
    
    
      } else if (frame == "ParallelogramB") {
    
      }
      // 坐标参数
      var paramCoordinate = { x0,rd,r,cutLine,cutFilletRadius,w,h1,h,d,xa, ya, xb, yb, xc, yc, xd, yd, xf, yf, xg, yg, xh, yh, xi, yi,glassW,glassH};
      const allKeys = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(model.plate.models)));
      var areaPoint = "";
      console.log("//角7、地弹簧3 ------", allKeys)
      if (allKeys[0] == frame) {
            allKeys.shift();//去掉数组第一个元素
      }
      console.log("//角7、地弹簧3 位置去掉数组第一个元素------", allKeys)
      switch (area) {
            case "1": areaPoint = "A"; break;
            case "2": areaPoint = "B"; break;
            case "3": areaPoint = "C"; break;
            case "4": areaPoint = "D"; break;
            case "6": areaPoint = "F"; break;
            case "7": areaPoint = "G"; break;
            case "8": areaPoint = "H"; break;
            case "9": areaPoint = "I"; break;
      }
      /**
      * 画图
      * 
      */
      var ObjName = "myCopperClipGapH" + areaPoint;
      var ObjNameMmyCopperClipGapH = "myCopperClipGapH" + areaPoint + "Mark";//角标记
      ObjName = creatmyCopperClipGapH(areaPoint, paramCoordinate);//图形
      console.log("ObjName===|||||||||", ObjName);
      ObjNameMmyCopperClipGapH = creatmyCopperClipGapHMark(outParam, areaPoint, paramCoordinate, inputParam, fixedParam, OffsetParam, zoom);//图形
      console.log("ObjNameMmyCopperClipGapH===|||||||||角标注", ObjNameMmyCopperClipGapH);
      console.log("cutPlate.models====************", cutPlate.models),
            console.log("plate.models====**************", plate.models),
            console.log("markers.models====*************", markers.models),
         // myCopperClipAMakerH,myCopperClipAMakerX,myCopperClipAMakerR,myCopperClipAMakerW,myCopperClipAMakerH1,myCopperClipAMakerD
            cutPlate.models["TypeGapes_myCopperClipGapH" + areaPoint + myHolesNum] = ObjName[1];
      plate.models["TypeGapes_myCopperClipGapH" + areaPoint + myHolesNum] = ObjName[1];
      markers.models["TypeGapes_myCopperClipGapH" + areaPoint + myHolesNum] = ObjName[1];
      markers.models["TypeGapes_myCopperClipGapHH" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyCopperClipGapH[0];
      markers.models["TypeGapes_myCopperClipGapHX" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyCopperClipGapH[1];
      markers.models["TypeGapes_myCopperClipGapHR" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyCopperClipGapH[2];
      markers.models["TypeGapes_myCopperClipGapHW" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyCopperClipGapH[3];
      markers.models["TypeGapes_myCopperClipGapHH1" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyCopperClipGapH[4];
      markers.models["TypeGapes_myCopperClipGapHD" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyCopperClipGapH[5];

myHolesNum++;
return{plate,cutPlate,markers, myHolesNum}
};


export default CopperClipGap;